import axios from 'services/axiosInstance';

export interface HouseTotalsRow {
  houseId: string;
  houseName: string;
  totalPoints: number;
  awardCount: number;
}

export function getSchoolHousePointsTotalsCurrentYear(activeSchoolId: string) {
  return axios
    .get(`${window.apiBase}/public/schools/${activeSchoolId}/awardEvents/current/houseTotals`)
    .then(response => response.data as HouseTotalsRow[]);
}
